namespace RioERP.Reports {
    export namespace InvoiceBillingItemsReportService {
        export const baseUrl = 'Reports/InvoiceBillingItemsReport';

        export declare function Create(request: Serenity.SaveRequest<InvoiceBillingItemsReportRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<InvoiceBillingItemsReportRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<InvoiceBillingItemsReportRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<InvoiceBillingItemsReportRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Reports/InvoiceBillingItemsReport/Create",
            Update = "Reports/InvoiceBillingItemsReport/Update",
            Delete = "Reports/InvoiceBillingItemsReport/Delete",
            Retrieve = "Reports/InvoiceBillingItemsReport/Retrieve",
            List = "Reports/InvoiceBillingItemsReport/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>InvoiceBillingItemsReportService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
